"use client"

import { Check, ChevronsUpDown, AppWindow } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { useSelectedApp } from "@/hooks/use-selected-app"
import { setSelectedAppId } from "@/lib/api"

export function AppSwitcher() {
  const [open, setOpen] = useState(false)
  const { selectedAppId, selectedApp, selectApp, apps } = useSelectedApp()
  
  const handleAppSelect = (appId: string) => {
    console.log('[AppSwitcher] handleAppSelect called with:', appId)
    selectApp(appId)
    // Also update the global API client app ID
    setSelectedAppId(appId)
    setOpen(false)
  }
  
  // Don't show if user has no apps or only one app
  if (apps.length <= 1) {
    return null
  }
  
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between"
        >
          <div className="flex items-center gap-2">
            <AppWindow className="h-4 w-4" />
            <span className="truncate">
              {selectedApp?.app_name || "Select app..."}
            </span>
          </div>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[250px] p-0">
        <Command>
          <CommandInput placeholder="Search apps..." />
          <CommandList>
            <CommandEmpty>No apps found.</CommandEmpty>
            <CommandGroup>
              {apps.map((app) => (
                <CommandItem
                  key={app.app_id}
                  value={app.app_name}
                  onSelect={() => handleAppSelect(app.app_id)}
                >
                  <Check
                    className={`mr-2 h-4 w-4 ${
                      selectedAppId === app.app_id
                        ? "opacity-100"
                        : "opacity-0"
                    }`}
                  />
                  <div className="flex flex-col">
                    <span>{app.app_name}</span>
                    <span className="text-xs text-muted-foreground">
                      {app.role}
                    </span>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}